import React from "react";
import { useSelector } from "react-redux";
import CustomTooltip from "../../../Core/Components/CustomTooltip";
import InfoCircleIcon from "../../../Common/Svgs/InfoCircleIcon";
import LineChart from "../../../Core/Components/LineChart";

const EnergyDistribution = ({
  timeFilter,
  // setTimeFilter,
  // energyDistributionButton,
  // setEnergyDistributionButton,
}) => {
  const { lineChart, energyConsumptionKPI } = useSelector(
    (state) => state.hubs,
  );

  // const getEnergyConsumed = () => {
  //   if (!lineChart.length) return "--";

  //   let total = 0;

  //   lineChart?.forEach((item) => {
  //     total = item?.data?.reduce((acc, current) => {
  //       acc += parseFloat(current?.y || 0);
  //       return acc;
  //     }, 0);
  //   });

  //   if (Number.isNaN(total)) return "--";
  //   return total >= 0 ? parseFloat(total).toFixed(0) : "--";
  // };

  const getEnergyConsumed = () => {
    return Number(energyConsumptionKPI?.totalConsumedCombined || 0).toFixed(0);
  };

  // const getTotal = useCallback(() => {
  //   const solar = lineChart?.find((l) => l.id === "Solar");
  //   const storage = lineChart?.find((l) => l.id === "Storage");

  //   const solarTotal = solar?.data?.reduce((acc, current) => {
  //     acc += parseFloat(current?.y || 0);
  //     return acc;
  //   }, 0);

  //   const storageTotal = storage?.data?.reduce((acc, current) => {
  //     acc += parseFloat(current?.y || 0);
  //     return acc;
  //   }, 0);

  //   console.log({ solarTotal, storageTotal });
  // }, [lineChart]);

  // useEffect(() => {
  //   getTotal();
  // }, [getTotal]);

  return (
    <div className="bg-background-white p-6 rounded-md border border-light-grey">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-x-2">
          <img
            src="/assets/icons/hubs/energy-distribution.svg"
            className="w-5 h-5"
            alt="energy-distribution"
          />

          <p className="font-poppins text-base font-medium">
            Energy Distribution
          </p>

          <CustomTooltip tooltipTitle="View the historical of energy distribution across each section of your hub">
            <div className="cursor-pointer">
              <InfoCircleIcon size={20} className="text-dark-gray" />
            </div>
          </CustomTooltip>
        </div>

        {/* <div className="flex items-center gap-x-2">
          <TimeFilter
            variant="energy-distribution"
            filter={timeFilter}
            setFilter={setTimeFilter}
          />

          {hubDetailsEnergyConsumption?.map((item) => {
            const selected = energyDistributionButton?.id === item.id;

            return (
              <Button
                key={item.id}
                colors={selected ? "primary" : "white"}
                modifier="shadow"
                onClick={() => setEnergyDistributionButton(item)}
              >
                <div>{item?.name}</div>
              </Button>
            );
          })}
        </div> */}
      </div>

      <div className="mt-6 flex items-center gap-x-8">
        <div>
          <p className="font-poppins text-2xl text-dark-gray font-[200]">
            <span className="text-black font-semibold">
              {getEnergyConsumed()}
            </span>{" "}
            kWh
          </p>

          <p className="font-aileron text-xs font-normal text-dark-gray">
            Energy Consumed
          </p>
        </div>

        {/* <div>
          <p className="font-poppins text-2xl text-dark-gray font-[200]">
            <span className="text-black font-semibold">125</span> h
            <span className="text-black font-semibold"> 14</span> m
          </p>

          <p className="font-aileron text-xs font-normal text-dark-gray">
            Duration
          </p>
        </div> */}
      </div>

      <div className="mt-6 w-full h-[376px]">
        <LineChart data={lineChart} timeFilter={timeFilter} />
      </div>
    </div>
  );
};

export default EnergyDistribution;
